module.exports = __webpack_public_path__ + "static/media/klær.10a2a771.m4a";